import { Link } from "react-router-dom";
import { articles } from "@/mocks/article";

interface RelatedArticlesProps {
  relatedIds: string[];
}

export default function RelatedArticles({ relatedIds }: RelatedArticlesProps) {
  const related = relatedIds
    .map((id) => articles.find((a) => a.id === id))
    .filter(Boolean) as typeof articles;

  if (related.length === 0) return null;

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 text-center mb-3">
          相关爆料
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          这些瓜也不错，趁热吃
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {related.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-200/50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.01]"
            >
              <div className="aspect-[16/10] w-full">
                <img
                  src={article.heroImageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs text-primary-400 font-medium">
                  {article.category}
                </span>
                <h3 className="text-base font-heading font-bold text-foreground-100 mt-1.5 mb-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500">{article.views} 阅读</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}